import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthGaurdService } from '../service/auth-gaurd.service';
import { AuthService } from '../_services/auth.service';
import { UserActivityService } from '../_services/user-activity.service';

const TOKEN_HEADER_KEY = 'Authorization';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(
    private authGaurdService: AuthGaurdService, 
    private authService: AuthService,
    private userActivityService: UserActivityService
  ) { }

  intercept(httpRequest: HttpRequest<any>, httpHandler: HttpHandler): Observable<HttpEvent<any>> {

    let authReq = httpRequest;

    this.authGaurdService.loadToken();
    const token = this.authGaurdService.getToken();

    // HOA-8442: engine calls are now proxied by the Java backend under the standard
    // Spring Boot JWT flow, so there is no longer a special Basic/Bearer path to the
    // engine's private IP. All requests carry the Java JWT.
    if (this.authGaurdService.getToken() === null || this.authGaurdService.getToken() === "") {
      authReq = this.addBootTokenHeader(httpRequest, token);
    } else {
      // Check if token is expired and handle appropriately
      if (this.authGaurdService.isTokenExpired(this.authGaurdService.getToken())) {
        // Token is NOT expired, proceed normally
        authReq = this.addBootTokenHeader(httpRequest, token);
      } else {
        // Token is expired
        if (this.userActivityService.isUserActive() && !this.isRefreshing) {
          // User is active and we're not already refreshing, attempt silent refresh
          this.isRefreshing = true;
          this.generateToken();
        }
        // Continue with existing token - let session timeout handle expiry
        authReq = this.addBootTokenHeader(httpRequest, token);
      }
    }
    return httpHandler.handle(authReq);
  }

  private addBootTokenHeader(httpRequest: HttpRequest<any>, token: string) {
    return httpRequest.clone({ headers: httpRequest.headers.set(TOKEN_HEADER_KEY, 'Bearer ' + token) });
  }

  generateToken() {
    this.authService.login(this.authGaurdService.loginNetworkId().toLowerCase(), "12345678").subscribe(
      data => {
        this.authGaurdService.saveToken(data.accessToken);
        this.authGaurdService.saveUser(data);
        localStorage.removeItem('NOOOO');
        this.isRefreshing = false;
      }, (errorResponse: HttpErrorResponse) => {
        console.log(errorResponse);
        this.isRefreshing = false;
      }
    );
  }

}
